const {databaseServer} = require("../config/network");

const getCustomers = (token) => {
    return fetch(`${databaseServer}/customers`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const createCustomer = async (token, customer) => {
    return fetch(`${databaseServer}/customers`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(customer),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const editCustomerOnDb = async (token, customer) => {
    return fetch(`${databaseServer}/customers/${customer.id}`, {
        method: 'put',
        mode: 'cors',
        body: JSON.stringify(customer),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}


module.exports = {
    getCustomers,
    editCustomerOnDb,
    createCustomer
}